import { render, staticRenderFns } from "./EditTagDialog.vue?vue&type=template&id=71631447&scoped=true"
import script from "./EditTagDialog.vue?vue&type=script&lang=js"
export * from "./EditTagDialog.vue?vue&type=script&lang=js"
import style0 from "./EditTagDialog.vue?vue&type=style&index=0&id=71631447&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71631447",
  null
  
)

export default component.exports